import { TFunction } from 'i18next';
import { calendarTypesConfig, quarterStylesConfig } from '../../../config/fiscalCalendar';
import { VALUATION_METHODS } from '../constants';

export const getValuationMethodOptions = (t: TFunction) => [
  {
    value: VALUATION_METHODS.CURRENT_CASE_COST,
    label: t('inventory.inventoryValuationSettings.valuationMethods.currentCaseCost'),
  },
  {
    value: VALUATION_METHODS.DAILY_WEIGHTED_AVERAGE,
    label: t('inventory.inventoryValuationSettings.valuationMethods.dailyWeightedAverage'),
  },
  {
    value: VALUATION_METHODS.MONTHLY_WEIGHTED_AVERAGE,
    label: t('inventory.inventoryValuationSettings.valuationMethods.monthlyWeightedAverage'),
  },
];

export const getCalendarTypeOptions = () =>
  Object.values(calendarTypesConfig).map((config) => ({
    value: config.id,
    label: config.label,
  }));

export const getQuarterStyleOptions = () =>
  Object.values(quarterStylesConfig).map((config) => ({
    value: config.id,
    label: config.label,
  }));
